import { render, staticRenderFns } from "./SmeDigitalTransformation.vue?vue&type=template&id=c70a67de&scoped=true"
import script from "./SmeDigitalTransformation.vue?vue&type=script&lang=js"
export * from "./SmeDigitalTransformation.vue?vue&type=script&lang=js"
import style0 from "./SmeDigitalTransformation.vue?vue&type=style&index=0&id=c70a67de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70a67de",
  null
  
)

export default component.exports